import React from "react";
import { Button } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Section7() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const Navigate = useNavigate()

  return (
    <section>
      <div
        style={{
          padding: "5rem 1.5rem 2rem",
          backgroundColor: "#6E07F3",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "95%",
            backgroundColor: "#141c3a",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            marginTop: isSmallScreen ? "-10rem" : "-9rem",
            boxShadow: "0 5px 5px 0 rgba(0, 0, 0, 0.2), 0 0 0 1px #141c3a",
            borderRadius: "15px",
            flexDirection: isSmallScreen ? "column" : "row",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: isSmallScreen ? "" : "33.3333%",
              padding: ".75rem",
            }}
          >
            <h1
              style={{
                fontSize: "2rem",
                fontWeight: 800,
                color: "white",
                fontFamily: "Font1",
                letterSpacing: 1.5,
              }}
            >
              Work together!
            </h1>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: isSmallScreen ? "" : "33.3333%",
              padding: ".75rem",
            }}
          >
            <p
              style={{
                fontSize: "18px",
                fontWeight: 400,
                color: "white",
                fontFamily: "Font2",
              }}
            >
              I'm always open to discussing new ideas, product or partnership
              opportunities. I'll buy the coffee.
            </p>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: isSmallScreen ? "" : "33.3333%",
              padding: ".75rem",
            }}
          >
            <Button
            onClick={()=>Navigate("/contact")}
              variant="outlined"
              sx={{
                border: "2px solid #5BE9B9",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#5BE9B9",
                  color: "#141c3a",
                  border: "2px solid #141c3a",
                },
                padding: "12px 50px",
                borderRadius: "999px",
                textTransform: "none",
                fontFamily: "Font2",
                fontSize: "18px",
                mb: isSmallScreen ? "1.5rem" : "",
              }}
              startIcon={
                <svg
                  class="svg-inline--fa fa-hand-horns"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="far"
                  data-icon="hand-horns"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 384 512"
                  data-fa-i2svg=""
                  width="15px"
                  style={{ marginRight: "10px" }}
                >
                  <path
                    fill="currentColor"
                    d="M80 48c8.8 0 16 7.2 16 16V208v32H80c-5.5 0-10.8 .6-16 1.6V64c0-8.8 7.2-16 16-16zM16 64V272C6 285.4 0 302 0 320c0 0 0 0 0 0v24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V288 256 128c0-35.3-28.7-64-64-64s-64 28.7-64 64v50c-5.1-1.3-10.5-2-16-2c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.5 0-10.9 .7-16 2V64c0-35.3-28.7-64-64-64S16 28.7 16 64zM336 256v32 56c0 66.3-53.7 120-120 120H168c-66.3 0-120-53.7-120-120V320s0 0 0 0c0-17.7 14.3-32 32-32h40 40c8.8 0 16 7.2 16 16s-7.2 16-16 16H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14c35.3 0 64-28.7 64-64V256 240 128c0-8.8 7.2-16 16-16s16 7.2 16 16V256zM160 240H144V208c0-8.8 7.2-16 16-16s16 7.2 16 16v32 2c-5.1-1.3-10.5-2-16-2zm96 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V264 240c0-8.8 7.2-16 16-16s16 7.2 16 16v16z"
                  ></path>
                </svg>
              }
            >
              {" "}
              Let's do this
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section7;
